<div class="app-container">
  <page-header [icon]="'far-truck'" [title]="'suppliers'">
    <ng-container class="header-button">
      <btn
        *ngIf="canCreate"
        [routerLink]="['/supplier']"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        [label]="'supplier.create'"
        [title]="'supplier.create' | translate"
        data-cy="go-supplier"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form [filters]="filters" [entity]="'suppliers'" (onSubmit)="filter()" (onClearClick)="clearFilters()" [isFilterInvisible]="true">
      <form-row-input
        [(model)]="filters.name"
        (keydown.enter)="filter()"
        [label]="'suppliers.name'"
        [icon]="'far-list'"
        data-cy="supplier-name-filter"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="suppliers"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      (reloadList)="filter(1)"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
